import { Box, Typography } from '@mui/material';

import SectionTitle from './SectionTitle';

interface Props {
  disabled?: boolean;
}

const contents = [
  '無論在任何情況下，對我們來說，每位患者都是獨立的個體，擁有獨特的需求和關注點。我們的使命是在充滿精神關懷的環境中提供最佳的醫療服務。我們的使命使您——我們的患者和賓客——始終處於我們所做一切工作的核心位置。在您與我們相處的期間，您可能會對醫院、您的住院情況以及我們為患者和賓客提供的眾多服務有疑問。',
  '這份患者信息指南旨在幫助回答這些問題。如果您需要額外的信息或協助，請聯繫我們的患者信息服務台，電話：0000-0000。',
  '我們理解住院可能會讓患者及其家人感到壓力。請放心，我們隨時準備為您提供協助。請告知任何醫院員工，我們可以如何讓您的住院經歷更舒適或愉快。',
  '如果您對護理質量有投訴，您可以通過以下方式提交投訴：在線提交（網址___），傳真至質量監控辦公室（電話：0000-0000），或郵寄您的意見至質量監控辦公室。如果您對如何提交投訴有任何疑問，您可以聯繫質量監控辦公室，電話：0000-0000。',
];

const contents2 = [
  '入院',
  '大多數住院患者是通過預先安排入院或急診室入院。如果您對入院流程有任何疑問，請致電入院辦公室，電話：0000-0000。出於安全原因，負責辦理入院手續的入院辦公室每天晚上10:00至早上5:30對公眾關閉。在此期間，醫院唯一的公眾入口是通過急診室的受控訪問區域。',
];

const contents3 = [
  '患者隱私',
  '您可以在入院時或住院期間的任何時間致電入院辦公室（電話：0000-0000）申請“無信息”狀態。“無信息”狀態意味著根據法律規定，我們無法向來電者和來訪者確認您是否作為住院患者、門診患者或急診室患者在醫院接受治療。來電者和來訪者無法獲得您的房間號碼或房間的直撥電話，但您可以根據自己的意願將這些信息分享給親朋好友。同樣，您將不會收到鮮花、郵件或其他送遞物品，除非這些物品明確標註您的正確房間號碼。如果您有任何疑問，請致電入院辦公室，電話：0000-0000。',
];

const contents4 = [
  '房間分配',
  '我們提供豪華房、私人房、半私人房和普通房。雖然我們無法保證提供特定類型的房間，但我們會盡力滿足您的房間需求。',
];

const FirstContents = (props: Props) => {
  const { disabled } = props;

  return (
    <>
      <Box
        sx={{
          width: '98%',
          margin: '48px auto 24px auto',
          border: '1px solid lightgray',
          padding: '10px',
        }}
      >
        {contents.map((v, i) => {
          if (i === 0) {
            return (
              <Typography
                sx={{
                  fontWeight: '400',
                  fontSize: '14px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          if (i === contents.length - 1) {
            return (
              <Typography
                sx={{
                  fontWeight: '400',
                  fontSize: '14px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          return (
            <Typography
              sx={{
                fontWeight: '400',
                fontSize: '14px',
                lineHeight: '24px',
                whiteSpace: 'pre-wrap',
              }}
            >
              {v}
              <p />
            </Typography>
          );
        })}
      </Box>

      <SectionTitle title="When You Arrive" />

      <Box
        sx={{
          width: '98%',
          margin: '48px auto 24px auto',
          border: '1px solid lightgray',
          padding: '10px',
        }}
      >
        {contents2.map((v, i) => {
          if (i === 0) {
            return (
              <Typography
                sx={{
                  fontWeight: '500',
                  fontSize: '12px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          if (i === contents2.length - 1) {
            return (
              <Typography
                sx={{
                  fontWeight: '400',
                  fontSize: '14px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          return (
            <Typography
              sx={{
                fontWeight: '400',
                fontSize: '14px',
                lineHeight: '24px',
                whiteSpace: 'pre-wrap',
              }}
            >
              {v}
              <p />
            </Typography>
          );
        })}
      </Box>

      <Box
        sx={{
          width: '98%',
          margin: '48px auto 24px auto',
          border: '1px solid lightgray',
          padding: '10px',
        }}
      >
        {contents3.map((v, i) => {
          if (i === 0) {
            return (
              <Typography
                sx={{
                  fontWeight: '500',
                  fontSize: '12px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          if (i === contents3.length - 1) {
            return (
              <Typography
                sx={{
                  fontWeight: '400',
                  fontSize: '14px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          return (
            <Typography
              sx={{
                fontWeight: '400',
                fontSize: '14px',
                lineHeight: '24px',
                whiteSpace: 'pre-wrap',
              }}
            >
              {v}
              <p />
            </Typography>
          );
        })}
      </Box>

      <Box
        sx={{
          width: '98%',
          margin: '48px auto 24px auto',
          border: '1px solid lightgray',
          padding: '10px',
        }}
      >
        {contents4.map((v, i) => {
          if (i === 0) {
            return (
              <Typography
                sx={{
                  fontWeight: '500',
                  fontSize: '12px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          if (i === contents4.length - 1) {
            return (
              <Typography
                sx={{
                  fontWeight: '400',
                  fontSize: '14px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          return (
            <Typography
              sx={{
                fontWeight: '400',
                fontSize: '14px',
                lineHeight: '24px',
                whiteSpace: 'pre-wrap',
              }}
            >
              {v}
              <p />
            </Typography>
          );
        })}
      </Box>
    </>
  );
};

export default FirstContents;
